import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Form, FormGroup, Label } from 'reactstrap';

export default class Pagination extends React.Component {
	constructor(props) {
		super(props);

		this.changePage = this.changePage.bind(this);

		this.state = {
			visiblePages: this.getVisiblePages(null, props.pages),
			numeroPagina: undefined,
			tamanhoPagina: undefined,			
			vNavButton: {
				visibility: 'hidden !important',
			},
		};
		

		this.defaultButton = props => <button {...props}>{props.children}</button>;
	}

	static propTypes = {
		children: PropTypes.node,
		nextText: PropTypes.string,
		onPageChange: PropTypes.func,
		onPageSizeChange: PropTypes.func.isRequired,
		page: PropTypes.number,
		PageButtonComponent: PropTypes.any,
		pages: PropTypes.number,
		pageSize: PropTypes.number,
		previousText: PropTypes.string,
		sortedData: PropTypes.array.isRequired,
		strTableInfo: PropTypes.string,
		onChange: PropTypes.func,
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.pages !== nextProps.pages) {
			this.setState({
				visiblePages: this.getVisiblePages(null, nextProps.pages),
			});
		}
		this.changePage(nextProps.page + 1);
	}

	filterPages = (visiblePages, totalPages) => {
		return visiblePages.filter(page => page <= totalPages);
	};

	getVisiblePages = (page, total) => {
		if (total < 7) {
			return this.filterPages([1, 2, 3, 4, 5, 6], total);
		} else {
			if (page % 5 >= 0 && page > 4 && page + 2 < total) {
				return [1, page - 1, page, page + 1, total];
			} else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
				return [1, total - 3, total - 2, total - 1, total];
			} else {
				return [1, 2, 3, 4, 5, total];
			}
		}
	};

	changePage(page) {
		this.setState({
			numeroPagina: page,
		});
		const activePage = this.props.page + 1;

		if (page === activePage) {
			return;
		}

		const visiblePages = this.getVisiblePages(page, this.props.pages);

		this.setState({
			visiblePages: this.filterPages(visiblePages, this.props.pages),
		});

		this.props.onPageChange(page - 1);
	}

	render() {
		const {
			PageButtonComponent = this.defaultButton,
			pageSize,
			onPageSizeChange,
			sortedData,
			strTableInfo,
		} = this.props;
		const { visiblePages } = this.state;
		const activePage = this.props.page + 1;
		
		return (
			<div className="Table__pagination">
				<Row>
					<Col>
						<div className="Table__prevPageWrapper">
						<PageButtonComponent
							className="Table__pageButton navButton"
							onClick={() => {
								if (activePage === 1) return;
								this.changePage(activePage - 1);
							}}
							disabled={activePage === 1}
						>
							{this.props.previousText}
						</PageButtonComponent>
					</div>
						<div className="Table__visiblePagesWrapper">
							{visiblePages.map((page, index, array) => {
								return (
									<PageButtonComponent
										key={page}
										className={
											activePage === page
												? 'Table__pageButton Table__pageButton--active'
												: 'Table__pageButton'
										}
										onClick={this.changePage.bind(null, page)}
										onChange={this.props.childPaginationValue(this.state.numeroPagina)}>
										{array[index - 1] + 2 < page ? `...${page}` : page}
									</PageButtonComponent>
								);
							})}
						</div>
						{/* <div className="Table__nextPageWrapper">
						<PageButtonComponent style={this.state.vNavButton}
							className="Table__pageButton navButton"
							onClick={() => {
								if (activePage === this.props.pages) return;
								this.changePage(activePage + 1);
							}}
							disabled={activePage === this.props.pages}
						>
							{this.props.nextText}
						</PageButtonComponent>
					</div> */}
					</Col>
					<Col>
						<Row className="justify-content-end tableInfo">
							<Col xs="auto pl-2">
								<span>
									{sortedData.length} {strTableInfo}
								</span>
							</Col>
							<Col xs="auto p-0 ml-4">
								<Form inline>
									{/* <FormGroup>
										<Label for="selectExibir">Exibindo: </Label>
										<Input
											onChange={e => onPageSizeChange(Number(e.target.value))}
											bsSize="sm"
											type="select"
											name="select"
											value={pageSize}
											id="selectExibir">
											<option value="10">10</option>
											<option value="25">25</option>
											<option value="50">50</option>
											<option value="100">100</option>
											<option value="1000">1000</option>
										</Input>
									</FormGroup> */}
								</Form>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}
}
